import Alert from '@mui/material/Alert';
import Button from '@mui/material/Button';

export interface DemoUnavailableNoticeProps {
	/** Retries seeding the sample project. */
	onRetry: () => void;
}

/**
 * Non-blocking notice shown when the sample demo could not be prepared. It never
 * hides the create-your-own path — the user can still start their own project.
 */
export function DemoUnavailableNotice({ onRetry }: DemoUnavailableNoticeProps) {
	return (
		<Alert
			severity='info'
			className='w-full max-w-2xl'
			action={
				<Button color='inherit' size='small' onClick={onRetry}>
					<span>Try again</span>
				</Button>
			}
		>
			The sample project is unavailable right now. Please try again later, or create your own project below.
		</Alert>
	);
}
